"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationMenuSpacer = void 0;
var React = require("react");
var Recompose = require("recompose");
var enhance = Recompose.compose(Recompose.setDisplayName('NavigationMenuSpacer'), Recompose.pure);
var component = function (_props) { return (React.createElement("div", { className: 'sok-navigation-menu-spacer' })); };
exports.NavigationMenuSpacer = enhance(component);
//# sourceMappingURL=index.js.map